import { gql } from '@apollo/client';
const SET_ORDER_SPECIFICATION_PRIORITY = gql `
  mutation SetOrderSpecificationPriority(
    $orderId: ID!
    $specificationId: ID!
    $priority: SpecificationPriority!
  ) {
    setOrderSpecificationPriority(
      orderId: $orderId
      specificationId: $specificationId
      priority: $priority
    ) {
      specification {
        id
        itemCode
        fancyName
        description
      }
      productionApproved
      productionStartDate
      virtualProductionEndDate
      sumOfModelQuantities
      totalProductionTimeMinutes
      priority
      manufacturer {
        id
        shortName
        fullName
        employeesCount
        picture
      }
      modelsCount
      suppliersCount
      manufacturerOccupiedDates
    }
  }
`;
export default SET_ORDER_SPECIFICATION_PRIORITY;
